import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLabelsController::index
* @see app/Http/Controllers/Tenant/Branch/NodeLabelsController.php:14
* @route '/nodes/user/labels'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/nodes/user/labels',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLabelsController::index
* @see app/Http/Controllers/Tenant/Branch/NodeLabelsController.php:14
* @route '/nodes/user/labels'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLabelsController::index
* @see app/Http/Controllers/Tenant/Branch/NodeLabelsController.php:14
* @route '/nodes/user/labels'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\Branch\NodeLabelsController::index
* @see app/Http/Controllers/Tenant/Branch/NodeLabelsController.php:14
* @route '/nodes/user/labels'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

const labels = {
    index: Object.assign(index, index),
}

export default labels